import { render, staticRenderFns } from "./CommunityShell.vue?vue&type=template&id=b2032132&scoped=true&"
import script from "./CommunityShell.vue?vue&type=script&lang=js&"
export * from "./CommunityShell.vue?vue&type=script&lang=js&"
import style0 from "./CommunityShell.vue?vue&type=style&index=0&id=b2032132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2032132",
  null
  
)

export default component.exports